import React from 'react';
import StepWizard from "react-step-wizard";
//Componente que carga Aspirantes/Responsables
import Persona from "./persona/Persona";
import AgregarOtroResponsable from "./persona/AgregarOtroResponsable";

//COMPONENTES PARA ESTABLECIMIENTOS
import Nivel from "./establecimiento/Nivel";
import SeleccionEstablecimiento from "./establecimiento/SeleccionEstablecimiento";

//COMPONENTES PARA EXTRAS
import Extras from "./extras/Extras";

//RESUMEN FINAL
import Resumen from "./resumen/Resumen";


//COMPONENTES DEL WIZARD
import Nav from "./wizard/Nav";

const PreInscripcionPasos = (props) => {
    return (
        <StepWizard initialStep={1} nav={<Nav />}>
            {/* 1 ASPIRANTE */}
            <Persona tipo={"aspirante"} />
            {/* 1 ASPIRANTE */}

            {/* 2 TUTOR/RESPONSABLE 1 */}
            <Persona tipo={"responsable"} posicion={0} />
            <AgregarOtroResponsable />
            {/* 2 TUTOR/RESPONSABLE 1 */}

            {/* TUTOR/RESPONSABLE 2 */}
            <Persona tipo={"responsable"} posicion={1} />
            <AgregarOtroResponsable />
            {/* TUTOR/RESPONSABLE 2 */}

            {/* TUTOR/RESPONSABLE 3 */}
            <Persona tipo={"responsable"} posicion={2} />
            <AgregarOtroResponsable />
            {/* TUTOR/RESPONSABLE 3 */}

            {/* ESTABLECIMIENTO */}
            <Nivel />
            <SeleccionEstablecimiento />
            {/* ESTABLECIMIENTO */}
            
            {/* EXTRAS */}
            <Extras />
            {/* EXTRAS */}

            {/* RESUMEN */}
            <Resumen {...props} />
            {/* RESUMEN */}
        </StepWizard>
    )
}

export default PreInscripcionPasos;